function initSpsPdp(root) {
  if (!root || root.dataset.spsReady === '1') return;
  root.dataset.spsReady = '1';

  const hero = root.querySelector('[data-sps-hero]');
  const heroMark = root.querySelector('[data-sps-hero-mark]');
  const heroPhoto = root.querySelector('[data-sps-hero-photo]');
  const heroLabel = root.querySelector('[data-sps-hero-label]');
  const colourButtons = root.querySelectorAll('[data-sps-colour]');
  const sizeButtons = root.querySelectorAll('[data-sps-size]');
  const placementButtons = root.querySelectorAll('[data-sps-placement]');
  const variantInput = root.querySelector('[data-sps-variant-id]');
  const priceEls = root.querySelectorAll('[data-sps-price], [data-sps-add-price]');
  const addBtn = root.querySelector('[data-sps-add]');
  const colourLabel = root.querySelector('[data-sps-colour-label]');
  const placementLabel = root.querySelector('[data-sps-placement-label]');
  const variantsEl = root.querySelector('[data-sps-variants]');
  const mediaEl = root.querySelector('[data-sps-media]');
  const badgeEl = root.querySelector('[data-sps-badge]');
  const zoomDialog = root.querySelector('[data-sps-zoom-dialog]');
  const zoomImg = root.querySelector('[data-sps-zoom-img]');
  const zoomStage = root.querySelector('[data-sps-zoom-stage]');
  const zoomTabs = root.querySelector('[data-sps-zoom-tabs]');
  const labelFront = root.getAttribute('data-label-front') || 'Front';
  const labelBadge = root.getAttribute('data-label-badge') || 'Badge';

  let variants = [];
  let mediaByGround = {};
  let mediaByCombo = {};
  let badgeUrl = '';
  let showingBadge = false;
  try {
    variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
  } catch (e) {
    variants = [];
  }
  try {
    const mediaList = JSON.parse(mediaEl ? mediaEl.textContent : '[]');
    (mediaList || []).forEach((item) => {
      if (!item || !item.ground || !item.url) return;
      if (item.kind === 'back') return;
      if (!mediaByGround[item.ground]) mediaByGround[item.ground] = item.url;
      const place = item.placement || 'left-chest';
      const key = item.ground + '|' + place;
      if (!mediaByCombo[key]) mediaByCombo[key] = item.url;
    });
  } catch (e) {
    mediaByGround = {};
    mediaByCombo = {};
  }
  try {
    const badge = JSON.parse(badgeEl ? badgeEl.textContent : '{}');
    badgeUrl = badge && badge.url ? badge.url : '';
  } catch (e) {
    badgeUrl = '';
  }

  const selected = () => ({
    colour: root.querySelector('[data-sps-colour][aria-pressed="true"]')?.getAttribute('data-sps-colour'),
    size: root.querySelector('[data-sps-size][aria-pressed="true"]')?.getAttribute('data-sps-size'),
    placement: root.querySelector('[data-sps-placement][aria-pressed="true"]')?.getAttribute('data-sps-placement'),
    ground: root.querySelector('[data-sps-colour][aria-pressed="true"]')?.getAttribute('data-ground') || 'bone'
  });

  const norm = (value) => String(value || '').toLowerCase().trim();

  const optionMatches = (opts, value) => {
    if (!value) return true;
    const needle = norm(value);
    return (opts || []).some((opt) => norm(opt) === needle);
  };

  const markThumb = (src) => {
    root.querySelectorAll('[data-sps-thumb]').forEach((thumb) => {
      thumb.setAttribute('aria-pressed', thumb.getAttribute('data-sps-thumb-src') === src ? 'true' : 'false');
    });
  };

  const showPhoto = (src, isBadge) => {
    if (!hero || !heroPhoto || !src) return;
    showingBadge = Boolean(isBadge);
    heroPhoto.src = src;
    hero.classList.add('has-photo');
    hero.classList.toggle('is-badge', showingBadge);
    const placeLabel = selected().placement || labelFront;
    if (heroLabel) heroLabel.textContent = showingBadge ? labelBadge : placeLabel;
    markThumb(src);
  };

  const placementSlug = (value) => {
    const n = norm(value);
    if (n.includes('right') && n.includes('sleeve')) return 'right-sleeve';
    if (n.includes('left') && n.includes('sleeve')) return 'left-sleeve';
    if (n.includes('right')) return 'right-chest';
    if (n.includes('left') || n.includes('chest')) return 'left-chest';
    return 'left-chest';
  };

  const photoForSelection = (variant) => {
    const { ground, placement } = selected();
    if (variant && variant.image) return variant.image;
    const combo = mediaByCombo[ground + '|' + placementSlug(placement)];
    return combo || mediaByGround[ground] || '';
  };

  const applyGround = (ground) => {
    if (hero) hero.setAttribute('data-ground', ground);
    if (heroMark) {
      const base = heroMark.getAttribute('data-mark');
      const file = ground === 'bone' ? base + '.svg' : base + '-reverse.svg';
      heroMark.src = heroMark.src.replace(/[^/]+$/, file);
    }
  };

  const matchVariant = () => {
    const { colour, size, placement } = selected();
    if (!variants.length) return;

    const hasColourButtons = colourButtons.length > 0;
    const hasSizeButtons = sizeButtons.length > 0;
    const hasPlacementButtons = placementButtons.length > 0;

    const found = variants.find((variant) => {
      const opts = variant.options || [];
      const colourOk = !hasColourButtons || optionMatches(opts, colour);
      const sizeOk = !hasSizeButtons || optionMatches(opts, size);
      const placementOk = !hasPlacementButtons || optionMatches(opts, placement);
      return colourOk && sizeOk && placementOk;
    }) || variants.find((variant) => {
      const opts = variant.options || [];
      const colourOk = !hasColourButtons || optionMatches(opts, colour);
      const placementOk = !hasPlacementButtons || optionMatches(opts, placement);
      return colourOk && placementOk;
    }) || variants[0];

    if (variantInput) variantInput.value = found.id;
    if (!showingBadge) {
      const src = photoForSelection(found);
      if (src) showPhoto(src, false);
    }
    priceEls.forEach((el) => {
      el.textContent = found.price_label;
    });
    if (addBtn) addBtn.disabled = found.available === false;

    sizeButtons.forEach((button) => {
      const label = button.getAttribute('data-sps-size');
      const match = variants.find((variant) => {
        const opts = variant.options || [];
        const sizeOk = optionMatches(opts, label);
        const colourOk = !hasColourButtons || optionMatches(opts, colour);
        const placementOk = !hasPlacementButtons || optionMatches(opts, placement);
        return sizeOk && colourOk && placementOk;
      });
      button.disabled = !match || match.available === false;
    });
  };

  colourButtons.forEach((button) => {
    button.addEventListener('click', () => {
      colourButtons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      applyGround(button.getAttribute('data-ground'));
      if (colourLabel) colourLabel.textContent = button.getAttribute('data-sps-colour');
      showingBadge = false;
      matchVariant();
    });
  });

  sizeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.disabled) return;
      sizeButtons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      matchVariant();
    });
  });

  placementButtons.forEach((button) => {
    button.addEventListener('click', () => {
      placementButtons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      if (placementLabel) placementLabel.textContent = button.getAttribute('data-sps-placement');
      showingBadge = false;
      matchVariant();
    });
  });

  const initialGround = selected().ground || 'bone';
  applyGround(initialGround);
  matchVariant();
  if (heroPhoto && heroPhoto.getAttribute('src')) {
    hero.classList.add('has-photo');
  }

  root.querySelectorAll('[data-sps-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-sps-thumb-src');
      if (src) showPhoto(src, false);
    });
  });

  const zoom = { scale: 1, x: 0, y: 0, view: 'shirt', dragging: false, lastX: 0, lastY: 0 };

  const shirtSrc = () => photoForSelection() || (heroPhoto && !showingBadge ? heroPhoto.src : '') || '';

  const applyZoomTransform = () => {
    if (!zoomImg) return;
    zoomImg.style.transform = 'translate(' + zoom.x + 'px, ' + zoom.y + 'px) scale(' + zoom.scale + ')';
  };

  const setZoomView = (view) => {
    zoom.view = view;
    const useBadge = view === 'badge' && badgeUrl;
    const src = useBadge ? badgeUrl : shirtSrc();
    if (zoomImg && src) zoomImg.src = src;
    if (zoomStage) zoomStage.classList.toggle('is-badge', Boolean(useBadge));
    zoom.scale = useBadge ? 1.15 : 4.6;
    zoom.x = 0;
    zoom.y = 0;
    let origin = '38% 36%';
    const slug = placementSlug(selected().placement);
    if (slug === 'right-chest') origin = '62% 36%';
    if (slug === 'left-sleeve') origin = '18% 42%';
    if (slug === 'right-sleeve') origin = '82% 42%';
    if (zoomImg) zoomImg.style.transformOrigin = useBadge ? '50% 50%' : origin;
    applyZoomTransform();
    root.querySelectorAll('[data-sps-zoom-view]').forEach((tab) => {
      const on = tab.getAttribute('data-sps-zoom-view') === (useBadge ? 'badge' : 'shirt');
      tab.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  const closeZoom = () => {
    if (!zoomDialog) return;
    zoomDialog.hidden = true;
    document.body.classList.remove('sps-zoom-open');
  };

  const openZoom = (view) => {
    if (!zoomDialog || !zoomImg) return;
    const next = view || (showingBadge && badgeUrl ? 'badge' : 'shirt');
    if (zoomTabs) zoomTabs.hidden = !badgeUrl;
    setZoomView(next);
    zoomDialog.hidden = false;
    document.body.classList.add('sps-zoom-open');
    const closeBtn = zoomDialog.querySelector('[data-sps-zoom-close]');
    if (closeBtn) closeBtn.focus();
  };

  root.querySelectorAll('[data-sps-zoom]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openZoom('shirt');
    });
  });

  root.querySelectorAll('[data-sps-open-badge]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (badgeUrl) openZoom('badge');
    });
  });

  if (hero) {
    hero.addEventListener('click', (event) => {
      if (event.target.closest('button')) return;
      if (!hero.classList.contains('has-photo')) return;
      openZoom('shirt');
    });
  }

  root.querySelectorAll('[data-sps-zoom-view]').forEach((tab) => {
    tab.addEventListener('click', () => setZoomView(tab.getAttribute('data-sps-zoom-view')));
  });

  root.querySelectorAll('[data-sps-zoom-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeZoom();
    });
  });

  if (zoomDialog) {
    zoomDialog.addEventListener('click', (event) => {
      if (event.target === zoomDialog) closeZoom();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && zoomDialog && !zoomDialog.hidden) closeZoom();
  });

  if (zoomStage) {
    zoomStage.addEventListener('wheel', (event) => {
      event.preventDefault();
      const next = zoom.scale + (event.deltaY < 0 ? 0.22 : -0.22);
      zoom.scale = Math.min(7, Math.max(1, next));
      applyZoomTransform();
    }, { passive: false });
    zoomStage.addEventListener('pointerdown', (event) => {
      zoom.dragging = true;
      zoom.lastX = event.clientX;
      zoom.lastY = event.clientY;
      zoomStage.setPointerCapture(event.pointerId);
    });
    zoomStage.addEventListener('pointermove', (event) => {
      if (!zoom.dragging) return;
      zoom.x += event.clientX - zoom.lastX;
      zoom.y += event.clientY - zoom.lastY;
      zoom.lastX = event.clientX;
      zoom.lastY = event.clientY;
      applyZoomTransform();
    });
    const stopDrag = () => {
      zoom.dragging = false;
    };
    zoomStage.addEventListener('pointerup', stopDrag);
    zoomStage.addEventListener('pointercancel', stopDrag);
  }
}

function bootSpsPdp() {
  document.querySelectorAll('.sps-pdp').forEach(initSpsPdp);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSpsPdp);
} else {
  bootSpsPdp();
}
document.addEventListener('shopify:section:load', (event) => {
  if (!event.target) return;
  event.target.querySelectorAll('.sps-pdp').forEach(initSpsPdp);
});
